var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgShare = function SvgShare(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M18 22q-1.2 0-2.1-.9a2.9 2.9 0 0 1-.8-2.8l-7-4.1c-.3.3-.6.4-1 .6L6 15q-1.2 0-2.1-.9T3 12c0-1.2.3-1.5.9-2.1A3 3 0 0 1 7 9.2l1 .6 7-4.1V5q0-1.2.9-2.1T18 2c1.2 0 1.5.3 2.1.9q.9.9.9 2.1c0 1.2-.3 1.5-.9 2.1a2.9 2.9 0 0 1-3.2.7c-.3-.2-.7-.3-1-.6l-7 4.1v.3a2.8 2.8 0 0 1 0 1.1l7 4.1c.3-.3.7-.4 1-.6A3 3 0 0 1 18 16q1.2 0 2.1.9T21 19c0 1.2-.3 1.5-.9 2.1q-.9.9-2.1.9"
  })));
};
export default SvgShare;